import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Select,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Radio,
  Empty,
  Image,
  Modal,
  Popover,
  Dropdown,
  Menu
} from "antd";

import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import { HomeOutlined,OrderedListOutlined, ArrowUpOutlined, ArrowDownOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import appLoaderAction from '../../../redux/action/app-loader-action';
import notifyUtitls from '../../../utils/notify-utils';
import photoGalleryService from "../../../services/photo-gallery-service";
import AddEditFolderDialog from "./AddEditFolderDialog";
import AddEditImageDialog from "./AddEditImageDialog";
import { galleryType } from "../../../constants/app-constants";
import GalleryPhoto from "../../../components/gallery/photo/index";
import ListCardGalleryPhoto from "../../../components/gallery/photo/list-card";
import fileUtils from "../../../utils/file-utils";
import Slide from "../../../components/gallery/photo/slide";
import { PlayCircleOutlined } from '@ant-design/icons';
import ImageGallery from 'react-image-gallery';
import { EditOutlined, DeleteOutlined, LinkOutlined, FolderOpenOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import "../../../styles/image-gallery.css"
const { confirm } = Modal;

const { Option } = Select;
const { Panel } = Collapse;

const Photo = ({ isHtmlModal }) => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [isShowAddImageDialog, setIsShowAddImageDialog] = useState(false);
  const [condition, setCondition] = useState({
    fileName: null,
    type: null,
    parent: 'root',
    path: '',
    folder: false
  });
  const [editFolderData, setEditFolderData] = useState(null);
  const [editImageData, setEditImageData] = useState(null);
  const [displayList, setDisplayList] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [displayGroup, setDisplayGroup] = useState('a');
  const [currentParent, setCurrentParent] = useState("root");
  const [currentPath, setCurrentPath] = useState([]);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [clickPopOver, setClickPopOver] = useState(false);
  const [sortAscFlag, setSortAscFlag] = useState(false);

  useEffect(() => {
    doSearch();
  }, []);


  const handleCancel = () => {
    setCurrentImage(0);
    setIsModalVisible(false);
  };


  const onChangeSelection = (value) => {
    setCondition({ ...condition, type: value, parent: null });
  }

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value, parent: null });
  }


  const doSearch = async (payload) => {
    try {
      dispatch(appLoaderAction.enable());
      let result;
      if (payload) {
        result = await photoGalleryService.search(payload);
        setCurrentParent(payload.parent);
        setDisplayList(result.list);
      } else {
        const newCondition = { fileName: condition.fileName, type: condition.type, parent: condition.parent }
        result = await photoGalleryService.search(newCondition);
        setCurrentParent(condition.parent);
        setCurrentPath([]);
        setDisplayList(result.list);
      }
      const imageList = [];
        const fileList = result.list?.filter((item) => !item.folder);
        fileList.forEach((item) => {
          let imgPath = fileUtils.getGalleryRenderUrl(
            galleryType.PHOTO,
            item.path,
            item.fileName,
          )
          fileUtils.getGalleryRenderUrl(galleryType.PHOTO, item.fileName, item.path);
  
          imageList.push({
            original: imgPath,
            thumbnail: imgPath,
            id: item.id,
            type: item.type,
          });
        });
        setImageList(imageList);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  const onOpenFolder = async (value) => {
    try {
      // console.log('test clickOpen', value);
      dispatch(appLoaderAction.enable());
      const newCondition = { parent: value.id }
      const result = await photoGalleryService.search(newCondition);
      setCurrentParent(value.id);
      if (currentPath) {
        setCurrentPath([
          ...currentPath,
          value.folderName
        ]);
      } else {
        setCurrentPath([
          value.id,
          value.folderName
        ]);
      }

      const imageList = [];
      const fileList = result.list?.filter((item) => !item.folder);
      fileList.forEach((item) => {
        let imgPath = fileUtils.getGalleryRenderUrl(
          galleryType.PHOTO,
          item.path,
          item.fileName,
        )
        fileUtils.getGalleryRenderUrl(galleryType.PHOTO, item.fileName, item.path);

        imageList.push({
          original: imgPath,
          thumbnail: imgPath,
          id: item.id,
          type: item.type,
        });
      });
      setImageList(imageList);

      setCurrentFolder(value.folderName);
      setDisplayList(result.list);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  }

  const onClearSearch = () => {
    setCondition({
      fileName: null,
      type: null,
      parent: 'root',
      folder: false
    });
    setDisplayList(null);
    setCurrentParent("root");
    setCurrentPath([]);
    setCurrentFolder(null);
  }

  const displayGroupHandler = (event) => {
    setDisplayGroup(event.target.value);
  }

  const onAddFolder = () => {
    setEditFolderData(null);
    setIsShowAddFileDialog(true);
  }

  const onAddImage = () => {
    setIsShowAddImageDialog(true);
    setEditImageData(null);
  }

  const onCancelAddFolder = () => {
    setIsShowAddFileDialog(false);
    setEditFolderData(null);
  };

  const onAddFolderComplete = () => {
    setEditFolderData(null);
    setIsShowAddFileDialog(false);
    doSearch({ parent: currentParent })
  };

  const onCancelAddImage = () => {
    setIsShowAddImageDialog(false);
    setEditImageData(null);
  };

  const onAddImageComplete = () => {
    setIsShowAddImageDialog(false);
    setEditImageData(null);
    doSearch({ parent: currentParent })
  };

   const showModal = (data) => {
  
    const index = imageList.findIndex((item) => item.id === data.id);
  
    setCurrentImage(index);
    setIsModalVisible(true);
  };

  const onClickEdit = async (value) => {
    // console.log('test clickEdit', value);
    try {
      dispatch(appLoaderAction.enable());
      // const editData = await photoGalleryService.getById({id: id});
      value.folder ? onEditFolder(value) : onEditImage(value);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onEditImage = (data) => {
    setIsShowAddImageDialog(true);
    setEditImageData(data);
  }

  const onEditFolder = (data) => {
    setEditFolderData(data);
    setIsShowAddFileDialog(true);
  }

  const onConfirmDelete = (id) => {
    confirm({
      title: 'คุณต้องการลบใช่หรือไม่ ?',
      icon: <ExclamationCircleOutlined />,
      okText: 'ยืนยัน',
      okType: 'danger',
      cancelText: 'ยกเลิก',
      onOk() {
        onDelete(id);
      },
      onCancel() {
        
      },
    });
    // onDelete(id);
  }

  const onDelete = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      await photoGalleryService.remove({ deleteId: id });
      dispatch(appLoaderAction.disale());
      notifyUtitls.success('สำเร็จ', 'ลบข้อมูลสำเร็จ');
      doSearch({ parent: currentParent })
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  // function showDeleteConfirm() {
  //   confirm({
  //     title: 'Are you sure delete this task?',
  //     icon: <ExclamationCircleOutlined />,
  //     content: 'Some descriptions',
  //     okText: 'Yes',
  //     okType: 'danger',
  //     cancelText: 'No',
  //     onOk() {
  //       console.log('OK');
  //     },
  //     onCancel() {
  //       console.log('Cancel');
  //     },
  //   });
  // }

  const onEmbed = async (id) => {
    dispatch(appLoaderAction.enable());
    await photoGalleryService.generateLinkPhotoGalleryById({ id: id })
      .then((res) => {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(res.link);
        } else {
          let textArea = document.createElement("textarea");
          textArea.value = res.link;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
        }
        notifyUtitls.success('สำเร็จ', 'สร้างลิ้งค์');
      }).catch((err) => {
        notifyUtitls.error(err);
      }).finally(() => {
        dispatch(appLoaderAction.disale());
      });
  }

  const moveFileHandler = async (fileMove, folder) => {
    // console.log('dragValue', fileMove);
    // console.log('folder,', folder);

    if (folder.folder !== 'true') {
      try {
        dispatch(appLoaderAction.enable());
        let path = "/"
        if (currentPath) {
          currentPath.forEach((res) => {
            path = path + res + "/";
          });
          path = path + folder.folderName + "/"
        } else {
          path = path + folder.folderName + "/"
        }

        const moveValue = {
          bean: {
            id: fileMove.id,
            fileName: fileMove.fileName,
            type: fileMove.type,
            path: fileMove.path,
            parent: folder.id,
            folder: fileMove.folder,
            newPath: path
          }
        }
        await photoGalleryService.moveFile(moveValue);
        doSearch({ parent: currentParent })
        dispatch(appLoaderAction.disale());
        notifyUtitls.success('สำเร็จ', 'ย้ายข้อมูลสำเร็จ');
      } catch (err) {
        dispatch(appLoaderAction.disale());
        notifyUtitls.error(err);
      }
    }
  }

  const onSort = (value) => {
    switch (value) {
      case 'sortName':
        const newDisplayListName = displayList.sort((a, b) => {
          const prevFname = a.folderName || a.fileName;
          const nextFname = b.folderName || b.fileName;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }
        });
        setDisplayList([...newDisplayListName]);
        break;
      case 'sortSize':
        const newDisplayListSize = displayList.sort((a, b) => {
          const prevFname = a.size;
          const nextFname = b.size;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
              if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }          
        });
        setDisplayList([...newDisplayListSize]);
        break;
      case 'sortDate':
        const newDisplayListDate = displayList.sort((a, b) => {
          const prevFname = a.updateTime;
          const nextFname = b.updateTime;
          if (!sortAscFlag) {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return -1;
            }
            if ( prevFname > nextFname ){
              return 1;
            }
            return 0;
          } else {
            setSortAscFlag(!sortAscFlag);
            if ( prevFname < nextFname ){
              return 1;
            }
            if ( prevFname > nextFname ){
              return -1;
            }
            return 0;
          }   
        });
        setDisplayList([...newDisplayListDate]);
        break;
      default:
        break;
    }
  }

  const menu = (
    <Menu>
      <Menu.Item key="sortName" onClick={(event) => onSort(event.key)}>
        Sort by Name
      </Menu.Item>
      <Menu.Item key="sortSize"  onClick={(event) => onSort(event.key)}>
        Sort by Size
      </Menu.Item>
      <Menu.Item key="sortDate"  onClick={(event) => onSort(event.key)}>
        Sort by Date
      </Menu.Item>
    </Menu>
  );

  const downloadHandler = (data) => {
    const downloadUrl = fileUtils.getGalleryRenderUrl(
      galleryType.PHOTO,
      data.path,
      data.fileName
    )

    window.open(downloadUrl);
  }

  const onSelectPath = (parentId) => {
		const { condition, parents } = this.state;
		parents.pop();
		let idx = parents.findIndex((data) => data.id == parentId);
		let parentNew = parents.slice(0, idx + 1);
		condition.parent = parentId;
		this.setState({ condition, parents: parentNew }, () => {
			this.doSearchPhotoGallery();
		});
	}

  const handleClickPopOverChange = (flag) => {
		setClickPopOver(flag);
	};

  const renderCurrentPath = (parents) => {
		let allPath = [];

		if (parents.length < 5) {
			allPath = parents.map((item, index) => {
				if (index === 0) {
					return (
						<span key={index}>
							<a onClick={index === parents.length - 1 ? null : () => onSelectPath(item.id)}>
								<img src={<HomeOutlined />} style={{ width: '30px' }} />
							</a>
						</span>
					);
				} else {
					return (
						<>
							<span
								style={{
									marginLeft: '10px',
									marginRight: '10px',
									verticalAlign: 'text-top',
									fontWeight: 400,
									fontSize: '20px',
								}}>
								{'>'}
							</span>
							<span style={{ verticalAlign: 'sub' }}>
								<a onClick={index === parents.length - 1 ? null : () => onSelectPath(item.id)}>
									{item.path}
								</a>
							</span>
						</>
					);
				}
			});
		} else {
			let hidePaths = parents.slice(1, parents.length - 1);
			let clickContent = hidePaths.map((item, index) => {
				return (
					<div
						key={index}
						style={{
							marginTop: '5px',
							marginBottom: '5px',
						}}>
						<img src={<FolderOpenOutlined/>} style={{ width: '30px' }} />
						<a
							style={{
								marginLeft: '10px',
							}}
							onClick={() => {
								onSelectPath(item.id);
								handleClickPopOverChange(false);
							}}>
							{item.path}
						</a>
					</div>
				);
			});

			allPath.push(
				<>
					<span>
						<a onClick={parents.length == 1 ? null : () => onSelectPath(parents[0].id)}>
							<img src={<HomeOutlined />} style={{ width: '30px' }} />
						</a>
					</span>
					<span
						style={{
							marginLeft: '10px',
							marginRight: '10px',
							verticalAlign: 'text-top',
							fontWeight: 400,
							fontSize: '20px',
						}}>
						{'>'}
					</span>

					<Popover
						content={<div>{clickContent}</div>}
						arrowPointAtCenter
						trigger={'click'}
						visible={clickPopOver}
						onVisibleChange={handleClickPopOverChange}>
						<span style={{ verticalAlign: 'sub', fontWeight: 400, fontSize: '20px' }}>
							<a>{'...'}</a>
						</span>
					</Popover>
					<span
						style={{
							marginLeft: '10px',
							marginRight: '10px',
							verticalAlign: 'text-top',
							fontWeight: 400,
							fontSize: '20px',
						}}>
						{'>'}
					</span>
					<span style={{ verticalAlign: 'sub' }}>
						<a>{parents[parents.length - 1].path}</a>
					</span>
				</>
			);
		}
		return allPath;
	};

  return (
    <div>
      <h2>รูปภาพ</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการแกลลอรี่</Breadcrumb.Item>
        <Breadcrumb.Item>รูปภาพ</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex">
        <div>
          {
            isHtmlModal === true ? (
              null
            ) : (
              <Button type="primary me-3" onClick={() => onAddImage()}>
                <Icon.Image className="me-1" size={18} /> อัปโหลดรูปภาพ
              </Button>
            )
          }
        </div>
        <div >
          {
            isHtmlModal === true ? (
              null
            ) : (
              <Button className="btn-line me-3" onClick={() => onAddFolder()}>
                <Icon.FolderPlus className="me-1" size={18} /> เพิ่มโฟล์เดอร์
              </Button>
            )
          }
        </div>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="ชื่อรูปภาพ" className="mb-0">
                      <Input
                        name="fileName"
                        value={condition.fileName}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="ชนิดรูปภาพ" className="mb-0" >
                      <Select allowClear value={condition.type} onChange={onChangeSelection}>
                        <Option key="jpg" value="jpg">jpg</Option>
                        <Option key="png" value="png">png</Option>
                        <Option key="jpeg" value="jpeg">jpeg</Option>
                        <Option key="gif" value="gif">gif</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch()}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <h5>รูปภาพ</h5>
        <div className="d-flex justify-content-between" style={{ paddingBottom: '20px' }}>
          <Radio.Group buttonStyle="solid" onChange={displayGroupHandler} value={displayGroup}>
            <Radio.Button key="a" value="a">
              <Icon.Grid size={18} />
            </Radio.Button>
            <Radio.Button key="b" value="b">
              <Icon.List size={18} />
            </Radio.Button>
          </Radio.Group>

          <Dropdown overlay={menu} >
            <Button style={{ height: '32px' }}>
              {
                sortAscFlag === true ? (
                  <ArrowDownOutlined />
                ) : (
                  <ArrowUpOutlined />
                )
              }
              <OrderedListOutlined />
            </Button>
          </Dropdown>

        </div>
        <div className="p-3 border ">
          <div className="d-flex justify-content-between align-items-center">
            <Breadcrumb>
              <Breadcrumb.Item href="">
                <HomeOutlined />
              </Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => doSearch()}>
                รูปภาพ
              </Breadcrumb.Item>
              {
                currentParent === "root" ? (
                  null
                ) : (
                  <Breadcrumb.Item onClick={() => doSearch({ parent: currentParent })}>
                    {currentFolder}
                    {/* {renderCurrentPath(currentPath)} */}
                  </Breadcrumb.Item>
                )
              }
            </Breadcrumb>
          </div>
          <p></p>

          {/* <Button onClick={showModal} icon={<PlayCircleOutlined />} >
            Autoplay
          </Button> */}

          <Image.PreviewGroup>
            {displayGroup === 'a' ?
              <div className="text-center my-4">
                {/* <Slide photoList={displayList} /> */}
                {displayList ? (
                  <GalleryPhoto
                    axis={'x'}
                    items={displayList}
                    onRemove={onConfirmDelete}
                    onEdit={onClickEdit}
                    groupValue={galleryType.PHOTO}
                    embedMenuList={onEmbed}
                    editMenuList={onClickEdit}
                    openMenuList={onOpenFolder}
                    moveFile={moveFileHandler}
                    onDownload={downloadHandler}
                    onClick={showModal}
                  />
                ) : (
                  <Empty />
                )}
              </div>
              :
              <div>
                {displayList ? (
                  <ListCardGalleryPhoto
                    axis={'x'}
                    items={displayList}
                    onRemove={onConfirmDelete}
                    onEdit={onClickEdit}
                    groupValue={galleryType.PHOTO}
                    embedMenuList={onEmbed}
                    editMenuList={onClickEdit}
                    openMenuList={onOpenFolder}
                    moveFile={moveFileHandler}
                    onDownload={downloadHandler}
                 
                  />
                ) : (
                  <Empty />
                )}
              </div>
            }
          </Image.PreviewGroup>
        </div>
      </Card>

      <AddEditFolderDialog
        isShow={isShowAddFileDialog}
        editData={editFolderData}
        currentParent={currentParent}
        currentPath={currentPath}
        onCancel={onCancelAddFolder}
        onSaveComplete={onAddFolderComplete}>
      </AddEditFolderDialog>

      <AddEditImageDialog
        isShow={isShowAddImageDialog}
        editData={editImageData}
        currentParent={currentParent}
        currentFolder={currentFolder}
        currentPath={currentPath}
        onCancel={onCancelAddImage}
        onSaveComplete={onAddImageComplete}>
      </AddEditImageDialog>

      <Modal
            title=""
            centered
            closable={false}
            visible={isModalVisible}
            onCancel={handleCancel}
            width="800px"
            destroyOnClose
            footer={null}>
            <ImageGallery play={true} items={imageList} startIndex={currentImage} slideInterval={3000} />
          </Modal>
    </div>
  );
};

export default Photo;
